module.exports = __webpack_public_path__ + "static/media/upload.c11a7d61.svg";